//import '../App.css';
import '../styles/commands.css'
import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';

// Tutorial for Making Navbar Component: https://www.youtube.com/watch?v=fL8cFqhTHwA
// Font Icons: https://fontawesome.com/
// Use npm start to start site
// npm run build to build site for deployment 

class CommandsList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    }

  }

  render() {

    return (
      <div className="App">

        <Navbar />

        <header className="Commands-header">


          <h2 class="main">Main Commands:</h2>
            <dl>
                <dt>Default Prefix: -</dt>
                <dt>Or use Slash Commands</dt>
                <br></br>

                <dt><b>setPrefix xxx/prefix xxx</b></dt>
                <dd>- Change the prefix to whatever you like, i.e -setPrefix !, will change the prefix to ! <br></br>(must have admin to use this)</dd>
            
                <dt><b>login</b></dt>
                <dd>- Login to be able to log your gym stats and share them with your fellow bros</dd>

                <dt><b>log</b></dt>
                <dd>- Display menu to log a new gym stat</dd>

                <dt><b>logw</b></dt>
                <dd>- Shortcut for logging your weight</dd>

                <dt><b>stats/stats @user</b></dt>
                <dd>- Display your stats (-stats), <br></br>or mention a user to display their stats (-stats @username)</dd>

                <dt><b>statPic</b></dt>
                <dd>- Choose to display your custom pfp, or your gym idol on your stat card</dd>

            </dl>
        <br></br>

        <br></br>
        <br></br>
        
        </header>

        <Footer />

      </div>
    );
  }

}

export default CommandsList;
